import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import { Col, Divider, Layout, Row, Space } from 'antd'
import moment from 'moment'

import AboutUsSection from 'src/modules/layouts/footer/AboutUsSection'
import BlogSection from 'src/modules/layouts/footer/BlogSection'
import CollabsSection from 'src/modules/layouts/footer/CollabsSection'
import GuideSection from 'src/modules/layouts/footer/GuideSection'
import HelpSection from 'src/modules/layouts/footer/HelpSection'
import InfoSection from 'src/modules/layouts/footer/InfoSection'
import QuickLinksSection from 'src/modules/layouts/footer/QuickLinksSection'
import ShopSection from 'src/modules/layouts/footer/ShopSection'
import StoresSection from 'src/modules/layouts/footer/StoresSection'
import { getShopifyBaseUrl, isFromCAWebsite } from 'src/utils/helper'

import './BonLookFooter.less'

const { Footer } = Layout

const BLOCK_NAME = 'bonlook-footer'
//TODO: From >1024 its regular, below that its mobile like menu
const BonLookFooter = (): ReactElement => {
  const { t } = useTranslation()
  const baseUrlShopify = getShopifyBaseUrl()
  const isFromCaWebsite = isFromCAWebsite()
  return (
    <>
      <Footer className={`${BLOCK_NAME} ${BLOCK_NAME}-links`}>
        <Row>
          <Col xs={24} sm={24} xxl={21}>
            <Row>
              <Col xs={24} md={20}>
                <Row gutter={[0, 30]} justify="space-between">
                  <Col span={24}>
                    <Row justify="space-between">
                      {isFromCaWebsite && (
                        <Col span={4}>
                          <ShopSection />{' '}
                        </Col>
                      )}
                      <Col span={4}>
                        <CollabsSection />
                      </Col>
                      {!isFromCaWebsite && (
                        <Col span={4}>
                          <StoresSection />
                        </Col>
                      )}

                      <Col span={4}>
                        <AboutUsSection />
                      </Col>
                      <Col span={4}>
                        <GuideSection />
                      </Col>
                      <Col span={4}>
                        <HelpSection />
                      </Col>
                    </Row>
                  </Col>
                  <Col span={24}>
                    <Row justify="space-between">
                      <Col span={4}>
                        <BlogSection />
                      </Col>
                      <Col span={19}>
                        <QuickLinksSection />
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
              <Col>
                <InfoSection />
              </Col>
            </Row>
          </Col>
        </Row>
      </Footer>
      <Footer className={`${BLOCK_NAME} ${BLOCK_NAME}-copyright`}>
        <Row>
          <Col xs={24} sm={24} xxl={21}>
            <Row>
              <Col xs={24} md={18}>
                <Space>
                  &copy; BonLook {moment().year()} <Divider type="vertical" />{' '}
                  <a href={`${baseUrlShopify}/policies/privacy-policy`}>
                    {t('common:footer.text.privacy_policy_terms')}
                  </a>
                </Space>
              </Col>
            </Row>
          </Col>
        </Row>
      </Footer>
    </>
  )
}

export default BonLookFooter
